import * as targetsMap from 'shared/targets'
import { Target } from 'shared/types'

export type TargetsMap = Record<string, Target>

export const TARGETS_MAP: TargetsMap = targetsMap
